import React, { FC } from 'react';
import { AnyFCO, FCOFields } from '../../../core/types/fcoTypes';
import { Badge, FlexGroup, FlexItem, Popover, Tag } from '@lithos';

const TagsCell: FC<{ fco: AnyFCO }> = ({ fco }) => {
  if (fco[FCOFields.TAGS].length === 0) {
    return <>-</>;
  }

  if (fco[FCOFields.TAGS].length === 1) {
    return (
      <div>
        <FlexGroup padding="0" gapSize="0.5" alignItems="flexStart">
          <FlexItem grow={0} shrink={1}>
            <Tag size="xs" category={fco[FCOFields.TAGS][0].key} label={fco[FCOFields.TAGS][0].value} icon />
          </FlexItem>
          <FlexItem>
            <></>
          </FlexItem>
        </FlexGroup>
      </div>
    );
  }

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <FlexGroup padding="0" gapSize="0.5" alignItems="flexStart">
        <FlexItem grow={0} shrink={1}>
          <Tag size="xs" category={fco[FCOFields.TAGS][0].key} label={fco[FCOFields.TAGS][0].value} icon />
        </FlexItem>
        <FlexItem grow="1" shrink={0}>
          <Popover
            trigger={<Badge label={`+${fco[FCOFields.TAGS].length - 1}`} size="xs" />}
            body={
              <FlexGroup padding="0.5" gapSize="1" direction="column">
                {fco[FCOFields.TAGS].map((tag, index) => {
                  if (index === 0) return;
                  return <Tag size="xs" category={tag.key} label={tag.value} icon />;
                })}
              </FlexGroup>
            }
          />
        </FlexItem>
      </FlexGroup>
    </div>
  );
};

export default TagsCell;
